import { render } from "./FileUploader.vue?vue&type=template&id=37fbe1c1"
import script from "./FileUploader.vue?vue&type=script&lang=ts"
export * from "./FileUploader.vue?vue&type=script&lang=ts"
script.render = render

export default script